// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Details_container__r2Mya {
  animation: Details_init__djzw2 0.3s 0.3s both;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

.Details_container__r2Mya .Details_header__VTjz7 {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.Details_container__r2Mya .Details_header__VTjz7 .Details_titleContainer__6CWe4 {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.Details_container__r2Mya .Details_header__VTjz7 .Details_titleContainer__6CWe4 h4 {
  width: 92%;
  text-align: center;
  font-size: 1.6rem;
  font-family: Roboto, sans-serif;
  font-weight: 300;
}

.Details_container__r2Mya .Details_header__VTjz7 .Details_arrowback__acseN {
  transition: 0.3s;
}

.Details_container__r2Mya .Details_header__VTjz7 .Details_arrowback__acseN:hover {
  transition: 0.3s;
  cursor: pointer;
  scale: 1.1;
  filter: brightness(0.8);
}

.Details_container__r2Mya .Details_data__DLBaa {
  margin-bottom: 20px;
}

.Details_container__r2Mya .Details_data__DLBaa .Details_accordion__JRikp {
  width: 100%;
  margin-bottom: 30px;
}

.Details_container__r2Mya .Details_data__DLBaa .Details_dataContainer__fVrVC {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  align-items: center;
  background-color: white;
  border-radius: 0 0 10px 10px;
  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);
  padding-bottom: 30px;
}

.Details_container__r2Mya .Details_data__DLBaa .Details_dataContainer__fVrVC .Details_item__lbF5I {
  margin-top: 20px;
  width: 200px;
}

.Details_container__r2Mya .Details_data__DLBaa .Details_dataContainer__fVrVC .Details_item__lbF5I h3 {
  font-size: 1.5rem;
  margin: 0 0 10px;
  font-weight: 300;
  font-family: Roboto, sans-serif;
}

.Details_container__r2Mya .Details_data__DLBaa .Details_dataContainer__fVrVC .Details_item__lbF5I p {
  font-size: 1rem;
  margin: 0;
  font-weight: 500;
  font-family: Roboto, sans-serif;
}

/*---Información---*/
.Details_container__r2Mya .Details_dataContainer__fVrVC .Details_tableContainer__R1lrF {
  border-radius: 10px;
  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);
}

.Details_container__r2Mya .Details_loader__zikHT {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
}

.Details_container__r2Mya .Details_gameName__mM7Aj {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 1.3rem;
  font-weight: 300;
}

/*---Title---*/
.Details_container__r2Mya .Details_name__rxpA1 {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.Details_container__r2Mya .Details_name__rxpA1 .Details_title__yjutK {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.Details_container__r2Mya .Details_name__rxpA1 .Details_title__yjutK h4 {
  text-align: center;
  font-size: 1.8rem;
  font-family: Roboto, sans-serif;
  font-weight: 300;
  margin-right: 20px;
}

.Details_container__r2Mya .Details_name__rxpA1 .Details_title__yjutK .Details_chip__jesAr {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
  border-radius: 10px;
  width: 6rem;
  height: 2rem;
}

@keyframes Details_init__djzw2 {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/Refactor User/Details/Details.module.css"],"names":[],"mappings":"AAAA;EACE,6CAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,8CAA8C;EAC9C,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":[".container {\n  animation: init 0.3s 0.3s both;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n}\n\n.container .header {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.container .header .titleContainer {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.container .header .titleContainer h4 {\n  width: 92%;\n  text-align: center;\n  font-size: 1.6rem;\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n}\n\n.container .header .arrowback {\n  transition: 0.3s;\n}\n\n.container .header .arrowback:hover {\n  transition: 0.3s;\n  cursor: pointer;\n  scale: 1.1;\n  filter: brightness(0.8);\n}\n\n.container .data {\n  margin-bottom: 20px;\n}\n\n.container .data .accordion {\n  width: 100%;\n  margin-bottom: 30px;\n}\n\n.container .data .dataContainer {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-evenly;\n  align-items: center;\n  background-color: white;\n  border-radius: 0 0 10px 10px;\n  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);\n  padding-bottom: 30px;\n}\n\n.container .data .dataContainer .item {\n  margin-top: 20px;\n  width: 200px;\n}\n\n.container .data .dataContainer .item h3 {\n  font-size: 1.5rem;\n  margin: 0 0 10px;\n  font-weight: 300;\n  font-family: Roboto, sans-serif;\n}\n\n.container .data .dataContainer .item p {\n  font-size: 1rem;\n  margin: 0;\n  font-weight: 500;\n  font-family: Roboto, sans-serif;\n}\n\n/*---Información---*/\n.container .dataContainer .tableContainer {\n  border-radius: 10px;\n  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);\n}\n\n.container .loader {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 30px;\n}\n\n.container .gameName {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  font-size: 1.3rem;\n  font-weight: 300;\n}\n\n/*---Title---*/\n.container .name {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.container .name .title {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.container .name .title h4 {\n  text-align: center;\n  font-size: 1.8rem;\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n  margin-right: 20px;\n}\n\n.container .name .title .chip {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 1rem;\n  border-radius: 10px;\n  width: 6rem;\n  height: 2rem;\n}\n\n@keyframes init {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Details_container__r2Mya`,
	"init": `Details_init__djzw2`,
	"header": `Details_header__VTjz7`,
	"titleContainer": `Details_titleContainer__6CWe4`,
	"arrowback": `Details_arrowback__acseN`,
	"data": `Details_data__DLBaa`,
	"accordion": `Details_accordion__JRikp`,
	"dataContainer": `Details_dataContainer__fVrVC`,
	"item": `Details_item__lbF5I`,
	"tableContainer": `Details_tableContainer__R1lrF`,
	"loader": `Details_loader__zikHT`,
	"gameName": `Details_gameName__mM7Aj`,
	"name": `Details_name__rxpA1`,
	"title": `Details_title__yjutK`,
	"chip": `Details_chip__jesAr`
};
export default ___CSS_LOADER_EXPORT___;
